import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function bommel() {
	gsap.registerPlugin(ScrollTrigger);

	document.querySelectorAll('.bommel').forEach(bommelEl => {
		if (!bommelEl.closest('.popup')) {
			gsap.from(bommelEl, {
				rotation: 125,
				ease: "none",
				scrollTrigger: {
					trigger: bommelEl,
					start: "top 100%",
					end: "bottom 0%",
					scrub: true,
				}
			});
		}
	});
}

export {bommel};
